import { render, staticRenderFns } from "./tracker-OrganizationsByStatus.vue?vue&type=template&id=0b8a05c0&scoped=true&"
import script from "./tracker-OrganizationsByStatus.vue?vue&type=script&lang=js&"
export * from "./tracker-OrganizationsByStatus.vue?vue&type=script&lang=js&"
import style0 from "./tracker-OrganizationsByStatus.vue?vue&type=style&index=0&id=0b8a05c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a05c0",
  null
  
)

export default component.exports